import { notification } from "antd";

const processSymfonyFlash = (data) => {
    if (Object.prototype.hasOwnProperty.call(data, "flash")) {
        flashError({ description: "Epa" });
    }
    return;
};

const flashError = (props) => {
    notification.error({
        message: props.title ? props.title : "Error",
        description: props.description,
    });
};

const flashWarning = (props) => {
    notification.warning({
        message: props.title ? props.title : "Warning",
        description: props.description,
    });
};

const flashSuccess = (props) => {
    notification.success({
        message: props.title ? props.title : "Success",
        description: props.description,
    });
};

const flashInfo = (props) => {
    notification.info({
        message: props.title ? props.title : "Info",
        description: props.description,
    });
};

export { flashError, flashWarning, flashSuccess, flashInfo, processSymfonyFlash };
